import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IExtensionManifestPropertiesService = ( createDecorator('extensionManifestPropertiesService'));
export { IExtensionManifestPropertiesService };
